import { useEffect, useState } from "react";
import { FaArrowRight, FaCheckCircle, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { get } from "../http/api";
import { getMediaUrl } from "../http/media";
import "./SharedProfile.css";

export default function SharedProfile({ url }) {
  const navigate = useNavigate();
  const match = String(url || "").match(/carrerup\.com\/user\/([^/?#]+)/i);
  const username = match ? decodeURIComponent(match[1]) : "";
  const [profile, setProfile] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!username) return setFailed(true);
    get(`profile/username/${encodeURIComponent(username)}`)
      .then(response => setProfile(response.data))
      .catch(() => setFailed(true));
  }, [username]);
  if (failed) return <div className="web-shared-profile unavailable">Profil indisponible</div>;
  if (!profile) return <div className="web-shared-profile loading">Chargement du profil…</div>;
  return (
    <button className="web-shared-profile" type="button" onClick={() => navigate(`/user/${profile.username}`)}>
      <span className="web-shared-profile-kicker">PROFIL CARRERUP</span>
      <span className="web-shared-profile-main">
        {profile.image ? <img src={getMediaUrl(profile.image)} alt="" /> : <i><FaUser /></i>}
        <span className="web-shared-profile-copy">
          <strong>{profile.display_name || profile.username}{Number(profile.is_verified) === 1 && <FaCheckCircle />}</strong>
          <small>@{profile.username}</small>
          <em>{profile.role || "CarrerUp"}</em>
        </span>
      </span>
      {profile.public?.bio && <span className="web-shared-profile-bio">{profile.public.bio}</span>}
      <span className="web-shared-profile-open">Voir le profil <FaArrowRight /></span>
    </button>
  );
}
